import { BToast, BSpinner } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import Advogado from '@/views/usuarios/layoutPerfil/Advogado'
import Estagiario from '@/views/usuarios/layoutPerfil/Estagiario'
import Cliente from '@/views/usuarios/layoutPerfil/Cliente'
import Correspondente from '@/views/usuarios/layoutPerfil/Correspondente'
import { mapState, mapActions } from 'vuex'
import mensagens from '@/util/mensagens'
import util from '@/util'

export default {
  name: 'perfil',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    'default-table': defaultTable,
    Advogado,
    Estagiario,
    Cliente,
    Correspondente
  },

  computed: {
    ...mapState('usuarios', ['dadosPerfil', 'dadosSalvosPerfilAdvogado', 'formulario', 'dadosRetorno', 'flagsDeControle'])
  },

  data: () => {
    return {
      comboTiposAcesso: [],
      comboPerfis: [],
      layoutPerfil: '',
      listaLayoutPerfil: [],
      dadosPopulados: {
        idAdvogado: null,
        oab: null,
        coordenador: null,
        tipoCorrespondente: null,
        idCorrespondente: null,
        capas: [],
        quemMeVisualiza: [],
        tiposAcao: [],
        perfilClientes: []
      }
    }
  },

  mounted () {
    this.obterTiposAcesso()
    this.obterPerfis()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirDadosPerfilUsuario']),

    async obterTiposAcesso () {
      try {
        const resposta = await this.axios.get('/usuarios/perfis')
        this.comboTiposAcesso = resposta.data.retorno.dados
      } catch (e) {
        this.comboTiposAcesso = []
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    async obterPerfis () {
      try {
        const resposta = await this.axios.get('/perfis')
        this.comboPerfis = resposta.data.retorno.dados
      } catch (e) {
        this.comboPerfis = []
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.trocarPerfil()
    },

    trocarPerfil () {
      let perfil = this.formulario.f_profiles
      this.listaLayoutPerfil = {
        '1': 'Advogado',
        '3': 'Cliente',
        '4': 'Correspondente',
        '5': 'Estagiario',
        '6': 'Financeiro'
      }
      this.layoutPerfil = this.listaLayoutPerfil[perfil]
    },

    async montarEstruturaDoPerfil () {
      this.trocarPerfil()

      switch (this.layoutPerfil) {
        case 'Advogado':
          await this.obterDadosSalvosAdvogado()
          break

        case 'Estagiario':
        case 'Cliente':
          await this.obterDadosSalvosDemaisPerfis()
          break

        case 'Correspondente':
          await this.obterDadosSalvosTipoDeCorrespondente()
          break

        case 'Financeiro':
          break
      }
      let estrutura = this.montarEstruturaPerfis()
      this.ActionDefinirDadosPerfilUsuario(estrutura)
    },

    montarEstruturaPerfis () {
      let idAdvogado = util.valorVazio(this.dadosPerfil.f_lawyer) ? null : this.dadosPerfil.f_lawyer
      let capas = util.valorVazio(this.dadosPerfil.f_capas) ? [] : this.dadosPerfil.f_capas
      let clientes = util.valorVazio(this.dadosPerfil.f_profiles_clients) ? [] : this.dadosPerfil.f_profiles_clients
      let oab = util.valorVazio(this.dadosPerfil.f_oab) ? null : this.dadosPerfil.f_oab
      let tipoAcao = util.valorVazio(this.dadosPerfil.f_actiontypes) ? [] : this.dadosPerfil.f_actiontypes
      let quemVisualiza = util.valorVazio(this.dadosPerfil.f_users_view) ? [] : this.dadosPerfil.f_users_view
      let idCorrespondente = util.valorVazio(this.dadosPerfil.f_id) ? null : this.dadosPerfil.f_id
      let tipoCorrespondente = util.valorVazio(this.dadosPerfil.f_type) ? null : this.dadosPerfil.f_type
      let coordenador = {
        'f_id': util.valorVazio(this.dadosPerfil.coordinator) ? null : this.dadosPerfil.coordinator.code,
        'user': { 'f_name': util.valorVazio(this.dadosPerfil.coordinator) ? null : this.dadosPerfil.coordinator.label }
      }
      const tiposPrazos = util.valorVazio(this.dadosPerfil.f_appointment_types) ? [] : this.dadosPerfil.f_appointment_types

      let estrutura = {
        'f_lawyer': !util.valorVazio(this.dadosPopulados.idAdvogado) ? this.dadosPopulados.idAdvogado : idAdvogado,
        'f_oab': !util.valorVazio(this.dadosPopulados.oab) ? this.dadosPopulados.oab : oab,
        'f_actiontypes': !util.valorVazio(this.dadosPopulados.tiposAcao) ? this.dadosPopulados.tiposAcao : tipoAcao,
        'f_users_view': quemVisualiza,
        'coordinator': !util.valorVazio(this.dadosPopulados.coordenador) ? this.dadosPopulados.coordenador : coordenador,
        'f_capas': !util.valorVazio(this.dadosPopulados.capas) ? this.dadosPopulados.capas : capas,
        'f_profiles_clients': !util.valorVazio(this.dadosPopulados.perfilClientes) ? this.dadosPopulados.perfilClientes : clientes,
        'f_id': !util.valorVazio(this.dadosPopulados.idCorrespondente) ? this.dadosPopulados.idCorrespondente : idCorrespondente,
        'f_type': !util.valorVazio(this.dadosPopulados.tipoCorrespondente) ? this.dadosPopulados.tipoCorrespondente : tipoCorrespondente,
        'f_appointment_types': tiposPrazos
      }
      return estrutura
    },

    async obterDadosSalvosDemaisPerfis () {
      let perfil = this.formulario.f_profiles
      const resposta = await this.axios.get('usuario/' + this.formulario.f_id + '/perfil/' + perfil)
      let flagSucesso = resposta.data.retorno.sucesso
      let mensagemRetorno = resposta.data.retorno.mensagem

      if (flagSucesso) {
        const dadosSalvosOutrosPerfis = resposta.data.retorno.dados

        switch (perfil) {
          case 3:
            this.dadosPopulados.perfilClientes = !util.valorVazio(dadosSalvosOutrosPerfis.f_profiles_clients) ? dadosSalvosOutrosPerfis.f_profiles_clients : []
            break

          default:
            if (!util.valorVazio(dadosSalvosOutrosPerfis.coordinator)) {
              this.dadosPopulados.coordenador = {
                'f_id': !util.valorVazio(dadosSalvosOutrosPerfis.coordinator) ? dadosSalvosOutrosPerfis.coordinator.f_id : null,
                'user': {
                  'f_name': !util.valorVazio(dadosSalvosOutrosPerfis.coordinator) ? dadosSalvosOutrosPerfis.coordinator.user.f_name : null
                }
              }
            }
            this.dadosPopulados.capas = !util.valorVazio(dadosSalvosOutrosPerfis.f_capas) ? dadosSalvosOutrosPerfis.f_capas : []
            break
        }
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
      }
    },

    obterDadosSalvosAdvogado () {
      let dadosSalvosDoPerfilAdvogado = this.dadosSalvosPerfilAdvogado
      let existemDadosSalvosAdvogado = !util.valorVazio(dadosSalvosDoPerfilAdvogado)

      if (existemDadosSalvosAdvogado) {
        this.dadosPopulados.idAdvogado = !util.valorVazio(dadosSalvosDoPerfilAdvogado.f_lawyer) ? dadosSalvosDoPerfilAdvogado.f_lawyer : null
        this.dadosPopulados.oab = !util.valorVazio(dadosSalvosDoPerfilAdvogado.f_oab) ? dadosSalvosDoPerfilAdvogado.f_oab : null
        this.dadosPopulados.tiposAcao = !util.valorVazio(dadosSalvosDoPerfilAdvogado.f_actiontypes) ? dadosSalvosDoPerfilAdvogado.f_actiontypes : []
      }
    },

    async obterDadosSalvosTipoDeCorrespondente () {
      const resposta = await this.axios.get('/correspondente/usuario/' + this.formulario.f_id)
      const dadosSalvosTipoDeCorrespondente = resposta.data.retorno.dados
      let flagSucesso = resposta.data.retorno.sucesso
      let mensagemRetorno = resposta.data.retorno.mensagem

      if (flagSucesso) {
        this.dadosPopulados.tipoCorrespondente = !util.valorVazio(dadosSalvosTipoDeCorrespondente) ? dadosSalvosTipoDeCorrespondente.f_type : null
        this.dadosPopulados.idCorrespondente = !util.valorVazio(dadosSalvosTipoDeCorrespondente) ? dadosSalvosTipoDeCorrespondente.f_id : null
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
